import { useContext } from "react"
import styles from "./SuccsesFreeSpins.module.css"
import { NAME_SERVER } from "../../../../Utils/NAME_HOST";
import { Context } from "../../../../index";
import { useNavigate } from "react-router-dom";
import UserService from "../../../../service/UserService";
function SuccsesFreeSpins({ props }) {
    const navigate = useNavigate()
    const { store } = useContext(Context)
    const url_image = NAME_SERVER + "/assets/" + "snake_pic2.png"
    
    return (
        <div className={styles.main}
            style={{ backgroundImage: `url(${url_image})`, width: store.isPhone ? window.innerWidth : "1000px" }}>
            <div className={styles.continaer}>
                {props.text}
                <button onClick={() => {
                    props.closeModel();
                    store.set_bonus(true)
                    
                    if (!props.disableNavigate) {
                        navigate("/pay")
                    }
                }}>Забрать бонус
                </button>

            </div>
        </div>
    )
}

export default SuccsesFreeSpins